<template>
  <div id="scroll" class="lower-page" v-bind:class="{ 'body-spnav': navOpen }">
    <header class="gnav" v-bind:class="{ 'open': navOpen }">
      <h1>
        <router-link :to="{ name: 'Home', params: { lang: activeLanguage } }">
          <img src="@/assets/img/client/logo.png" alt="GLOCALY MEMBERS SITE">
        </router-link>
      </h1>
      <div id="nav_toggle" v-on:click="navOpen = !navOpen">
        <div>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <fade-transition mode="out-in">
        <nav class="gnav_inner" key="navbar" v-show="navOpen">
          <ul>
            <li :class="{ current: ['Client Property List', 'Client Sold Property List', 'Client Property Detail', 'Client Property Map', 'Client Prefecture Property List'].includes($route.name), menu__single: true }">
              <a>{{ $t('business-property') }}</a>
              <ul>
                <li :class="{ current: ['Client Property List', 'Client Sold Property List', 'Client Property Detail'].includes($route.name), menu__child: true }">
                  <router-link :to="{ name: 'Client Property List', params: { lang: activeLanguage } }">
                    {{ $t('一覧から探す') }}
                  </router-link>
                </li>
                <li :class="{ current: ['Client Property Map', 'Client Prefecture Property List'].includes($route.name), menu__child: true }">
                  <router-link :to="{ name: 'Client Property Map', params: { lang: activeLanguage } }">
                    {{ $t('都道府県から探す') }}
                  </router-link>
                </li>
              </ul>
            </li>
            <li :class="{ current: ['rental-property-list', 'rental-property-detail'].includes($route.name), menu__single: true }">
              <a>{{ $t('rental_property_info') }}</a>
              <ul>
                <li :class="{ current: ['rental-property-list', 'rental-property-detail'].includes($route.name) && $route.params.type === 'residential-property-list', menu__child: true }">
                  <router-link :to="{ name: 'rental-property-list', params: { type: 'residential-property-list', lang: activeLanguage }}" v-html="$t('rental-residential-property')" />
                </li>
                <li :class="{ current: ['rental-property-list', 'rental-property-detail'].includes($route.name) && $route.params.type === 'commercial-property-list', menu__child: true }">
                  <router-link :to="{ name: 'rental-property-list', params: { type: 'commercial-property-list', lang: activeLanguage }}" v-html="$t('rental-commercial-property')" />
                </li>
              </ul>
            </li>
            <li :class="{ current: ['Client Blog List', 'Client Blog Detail'].includes($route.name) }">
              <router-link :to="{ name: 'Client Blog List', params: { lang: activeLanguage } }">
                {{ $t('members_blog') }}
              </router-link>
            </li>
            <li v-on:click="clearContactBody()" :class="{ current: ['Client Contact', 'Client Contact Confirmation'].includes($route.name) }">
              <router-link :to="{ name: 'Client Contact', params: { lang: activeLanguage } }">
                {{ $t('contact') }}
              </router-link>
            </li>
            <li :class="{ current: ['Client Member Information', 'Client Member Information Update', 'plan-information', 'business-property-list'].includes($route.name) }">
              <button class="btn-member" :style="iconBefore" v-bind:class="{ 'member-open': memberOpen }"
                @click.stop="memberOpen = !memberOpen"><span v-if="clientName" v-html="clientName.name" />{{sama}}</button>
              <fade-transition mode="out-in">
                <ul key="member" v-show="memberOpen" v-click-outside="onClose">
                  <li v-if="clientMenu.plan"><router-link :to="{ name: 'plan-information' }">{{ $t('plan_info') }}</router-link></li>
                  <li><router-link :to="{ name: 'Client Member Information' }">{{ $t('confirm_login_information') }}</router-link></li>
                  <li v-if="clientMenu.properties"><router-link :to="{ name: 'business-property-list' }">{{ $t('business_property_info') }}</router-link></li>
                  <li v-if="clientMenu.translation"><a :href="aiTranslatingUrl">{{ $t('ai_translation') }}</a></li>
                  <li><a @click="logout">{{ $t('logout') }}</a></li>
                </ul>
              </fade-transition>
            </li>
          </ul>
        </nav>
      </fade-transition>
      <lang v-if="$route.name.includes('404') === false" />
    </header>
  </div>
</template>

<script>
import FadeTransition from '@/views/client/FadeTransition.vue'
import lang from './language/language'
import Vue from 'vue'
import { mapState, mapActions } from 'vuex'

Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.eventSetDrag = function () {
      el.setAttribute('data-dragging', 'yes')
    }
    el.eventClearDrag = function () {
      el.removeAttribute('data-dragging')
    }
    el.eventOnClick = function (event) {
      var dragging = el.getAttribute('data-dragging')
      if (!(el === event.target || el.contains(event.target)) && !dragging) {
        vnode.context[binding.expression](event)
      }
    }
    document.addEventListener('touchstart', el.eventClearDrag)
    document.addEventListener('touchmove', el.eventSetDrag)
    document.addEventListener('click', el.eventOnClick)
    document.addEventListener('touchend', el.eventOnClick)
  },
  unbind: function (el) {
    document.removeEventListener('touchstart', el.eventClearDrag)
    document.removeEventListener('touchmove', el.eventSetDrag)
    document.removeEventListener('click', el.eventOnClick)
    document.removeEventListener('touchend', el.eventOnClick)
    el.removeAttribute('data-dragging')
  }
})

export default {
  data () {
    let language = this.$route.params.lang
    if (!language) language = Vue.$cookies.get('language')

    return {
      memberOpen: false,
      navOpen: false,
      activeLanguage: language,
      aiTranslatingUrl: process.env.VUE_APP_AI_TRANSLATING_URL
    }
  },
  components: {
    FadeTransition,
    lang
  },
  computed: {
    ...mapState('login', ['clientName', 'clientMenu']),
    sama: function () {
      if (this.$route.params.lang === 'ja') {
        return '様'
      }
      return null
    }
  },
  created () {
    this.getClientName()
  },
  methods: {
    ...mapActions('login', ['getClientName', 'sendLogoutRequestClient']),
    onClose () {
      this.memberOpen = false
    },
    logout: function () {
      this.sendLogoutRequestClient(this.activeLanguage)
    },
    iconBefore () {
      const buttonBefore = `.btn-member::before {background: url(${require('@/assets/img/client/member_icon.png')}) no-repeat }`
      const style = document.createElement('style')
      style.type = 'text/css'
      this.$el.appendChild(style)
      style.innerHTML = buttonBefore
    },
    clearContactBody (event) {
      this.$emit('clearBody', null)
    },
    handleResize () {
      var w = window.innerWidth
      var x = 1026
      if (w >= x) {
        this.navOpen = true
      } else if (w <= x && this.navOpen) {
        this.navOpen = false
      }
    }
  },
  mounted: function () {
    this.iconBefore()
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },
  beforeUpdate: function () {
    this.iconBefore()
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style lang="scss" src="@/assets/sass/client/index.scss">

</style>
